import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api, { API } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { rupee, waLink, cartWaText } from "@/lib/whatsapp";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Download, MessageCircle, Loader2 } from "lucide-react";

export default function OrderConfirmation() {
  const { id } = useParams();
  const { settings } = useApp();
  const [o, setO] = useState(null);

  useEffect(() => { window.scrollTo(0, 0); api.get(`/orders/${id}`).then((r) => setO(r.data)).catch(() => {}); }, [id]);

  if (!o) return <div className="flex justify-center py-40"><Loader2 className="w-8 h-8 animate-spin text-forest" /></div>;

  return (
    <div className="max-w-2xl mx-auto px-4 py-12 lg:py-16">
      <div className="bg-white rounded-[28px] soft-shadow p-8 text-center">
        <div className="w-16 h-16 rounded-full bg-earth/10 flex items-center justify-center mx-auto mb-4"><CheckCircle2 className="w-9 h-9 text-earth" /></div>
        <h1 className="font-heading text-3xl lg:text-4xl text-forest tracking-tight">Order Confirmed!</h1>
        <p className="text-brown/70 mt-2">Thank you, {o.address.full_name.split(" ")[0]}. Your order <b className="text-forest">{o.order_number}</b> has been placed.</p>

        <div className="bg-sand rounded-2xl p-5 mt-6 text-left space-y-3">
          {o.items.map((i, idx) => (
            <div key={idx} className="flex justify-between text-sm"><span className="text-brown">{i.name} × {i.qty}</span><span className="font-500">{rupee(i.price * i.qty)}</span></div>
          ))}
          <div className="border-t border-sage/30 pt-3 space-y-1.5 text-sm">
            <div className="flex justify-between"><span className="text-brown/70">Subtotal</span><span>{rupee(o.subtotal)}</span></div>
            {o.discount > 0 && <div className="flex justify-between"><span className="text-brown/70">Discount</span><span className="text-terracotta">- {rupee(o.discount)}</span></div>}
            <div className="flex justify-between"><span className="text-brown/70">Tax</span><span>{rupee(o.tax)}</span></div>
            <div className="flex justify-between"><span className="text-brown/70">Delivery</span><span>{o.delivery === 0 ? "FREE" : rupee(o.delivery)}</span></div>
            <div className="flex justify-between font-600 text-forest text-base pt-1"><span>Total ({o.payment_method})</span><span>{rupee(o.total)}</span></div>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 gap-3 mt-6">
          <a href={`${API}/orders/${o.id}/invoice`} target="_blank" rel="noreferrer" data-testid="download-invoice-btn"
            className="inline-flex items-center justify-center gap-2 bg-forest hover:bg-earth text-cream rounded-full h-12 font-500 transition-colors"><Download className="w-4 h-4" /> Download Invoice</a>
          <a href={waLink(settings.whatsapp_number, cartWaText(o.items, o))} target="_blank" rel="noreferrer" data-testid="confirm-wa-btn"
            className="inline-flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1eb85a] text-white rounded-full h-12 font-500 transition-colors"><MessageCircle className="w-4 h-4" /> Share on WhatsApp</a>
        </div>
        <Link to="/shop"><Button variant="ghost" className="mt-4 text-forest">Continue Shopping</Button></Link>
      </div>
    </div>
  );
}
